import styled, { keyframes } from "styled-components";
const basic = {
  color: "rgba(255, 255, 255, 1)",
};
export const StyleTitle = styled.div`
  color: ${basic.color};
  margin-bottom: 27px;
`;

const BasicLoading = ({ children, ...args }: any) => <div {...args}>{children || "Loading..."}</div>;
export const StyleLoading = styled(BasicLoading)`
  color: ${props => {
    return props.color || basic.color;
  }};
`;


const scrollLeft = ($startRate: any, $endRate: any, $unit = "%") => keyframes`
from {
  transform: translateX(${$startRate || 0}${$unit});
}
to {
  transform: translateX(${$endRate || -100}${$unit});
}`;

export const AnimateSlide = styled.div<any>`
  display: inline-block;
  white-space: nowrap;
  font-family: "Roboto Light";
  padding: 0px 4px;
  // animation-name: ${props => scrollLeft(props.$startRate, props.$endRate, props.$unit)};
  // animation-duration: ${props => props.$duration || 10}s;
  // animation-iteration-count: ${props => props.$count || "infinite"};
  // animation-timing-function: linear;
  // animation-play-state: ${props => props.$playState || "running"};
  // animation-delay: ${props => props.$delay || 0}s;
  // animation-direction: normal;
`;
